export default __webpack_public_path__ + "locales/lo-LA/ChangePasswordDialog.json?hash=42a3ba84eb2e9564ac01db1f5697f94f";